export default __webpack_public_path__ + "static/media/re-legend.49d65fde.png";